import { computed, unref } from 'vue';
import { useI18n } from 'vue-i18n';
import { STANDARD_BILLING_PERIOD_DAYS } from 'dashboard/constants/billingPeriods';

const SLUG_TO_TIER = {
  starter: 'STARTER',
  growth: 'GROWTH',
  advanced: 'ADVANCED',
};

export function useBillingPlanCardContent(planSource) {
  const { t, te } = useI18n();

  const plan = computed(() => unref(planSource));

  const tierKey = computed(() => SLUG_TO_TIER[plan.value?.slug] || null);

  const tierBasePath = computed(() =>
    tierKey.value
      ? `GENERAL_SETTINGS.BILLING_SELECT_PLAN_PAGE.${tierKey.value}`
      : null
  );

  const translateTier = suffix => {
    const base = tierBasePath.value;
    if (!base) return null;
    const key = `${base}.${suffix}`;
    return te(key) ? t(key) : null;
  };

  const features = computed(() => {
    const base = tierBasePath.value;
    if (!base) return [];
    const items = [];
    for (let i = 1; i <= 12; i += 1) {
      const key = `${base}.F${i}`;
      if (te(key)) items.push(t(key));
    }
    return items;
  });

  const featureIntro = computed(() => translateTier('FEATURE_INTRO'));

  return {
    features,
    featureIntro,
  };
}

export function resolvePlanDuration(plan, { days = 30 } = {}) {
  const targetDays = Number(days);
  return (
    (plan?.durations || []).find(
      d => !d.error && Number(d.days) === targetDays
    ) || null
  );
}

export function planHasDuration(plan, days) {
  return resolvePlanDuration(plan, { days }) != null;
}

export function catalogHasDuration(plans, days) {
  return (plans || []).some(plan => planHasDuration(plan, days));
}

export function firstAvailablePeriodDays(plans) {
  return (
    STANDARD_BILLING_PERIOD_DAYS.find(days =>
      catalogHasDuration(plans, days)
    ) || STANDARD_BILLING_PERIOD_DAYS[0]
  );
}
